import { createRouter, createWebHistory } from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import EmailAccounts from '../views/EmailAccounts.vue'
import Commandes from '../views/Commandes.vue'
import Emails from '../views/Emails.vue'
import Customers from '../views/Customers.vue'
import Produits from '../views/Produits.vue'
import Chat from '../views/Chat.vue'
import Transporteurs from '../views/Transporteurs.vue'
import About from '../views/About.vue'
import Login from '../views/Login.vue'
import NotificationChannels from '../views/NotificationChannels.vue'
import Analytics from '../views/Analytics.vue'
import OrganisationSettings from '../views/OrganisationSettings.vue'
import { useAuthStore } from '../stores/auth.js'

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/mail-accounts',
    name: 'EmailAccounts',
    component: EmailAccounts,
    meta: { requiresAuth: true }
  },
  {
    path: '/commandes',
    name: 'Commandes',
    component: Commandes,
    meta: { requiresAuth: true }
  },
  {
    path: '/emails',
    name: 'Emails',
    component: Emails,
    meta: { requiresAuth: true }
  },
  {
    path: '/customers',
    name: 'Customers',
    component: Customers,
    meta: { requiresAuth: true }
  },
  {
    path: '/produits',
    name: 'Produits',
    component: Produits,
    meta: { requiresAuth: true }
  },
  {
    path: '/chat',
    name: 'Chat',
    component: Chat,
    meta: { requiresAuth: true }
  },
  {
    path: '/transporteurs',
    name: 'Transporteurs',
    component: Transporteurs,
    meta: { requiresAuth: true }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: { requiresAuth: true }
  },
  {
    path: '/notification-channels',
    name: 'NotificationChannels',
    component: NotificationChannels,
    meta: { requiresAuth: true }
  },
  {
    path: '/analytics',
    name: 'Analytics',
    component: Analytics,
    meta: { requiresAuth: true }
  },
  {
    path: '/settings',
    name: 'OrganisationSettings',
    component: OrganisationSettings,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Navigation guard pour l'authentification
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  
  // Vérifier l'authentification si un token existe
  if (authStore.token && !authStore.isAuthenticated) {
    await authStore.checkAuth()
  }
  
  if (to.meta.requiresAuth && !authStore.isLoggedIn) {
    next('/login')
  } else if (to.name === 'Login' && authStore.isLoggedIn) {
    next('/')
  } else {
    next()
  }
})

export default router